import React, { useState } from 'react';

import { NavLink } from 'react-router-dom';

import Glavk12Logo from '@assets/images/main/12-glavk-logo.png';
import Glavk12Text from '@assets/images/main/12-glavk-logo-text.png';
import IZRULogo from '@assets/images/main/iz-ru-logo.svg';

import menuMobile from '@assets/images/items/menu-mobile.svg';
import menuMobileClose from '@assets/images/items/menu-mobile-close.svg';

export const PageMenu: React.FC = () => {
  const [show, changeShow] = useState(false);

  const clickChangeShow = () =>
    changeShow(!show);

  return (
    <header className="flex justify-between items-center border-b lg:border-b-0 pt-4 pb-4 lg:pt-8 lg:pb-8 px-5 lg:px-0 m-auto w-full max-w-1144">
      <NavLink className="flex items-center -mt-1" to="/">
        <img
          className="max-w-28 max-h-29 lg:max-w-46 lg:max-h-48 -mb-1 lg:-mb-0"
          src={Glavk12Logo}
          width="46"
          height="48"
          alt=""
        />
        <span className="ml-4 mt-1 lg:mt-0">
          <img
            className="max-w-83 max-h-60 lg:max-w-133 lg:max-h-60"
            src={Glavk12Text}
            width="133"
            height="60"
            alt=""
          />
        </span>
      </NavLink>
      <div
        className={`
          fixed
          flex-1
          h-full
          overflow-hidden
          lg:overflow-visible
          lg:h-auto
          top-0
          w-full
          lg:w-auto
          right-0
          lg:right-auto
          lg:relative
          z-20
          lg:z-auto
          transition
          delay-150
          duration-300
          transform
          lg:transform-none
          ${show ? ` translate-x-0` : ` translate-x-full`}
        `}
      >
        <div
          style={{ backgroundColor: show ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0.0)' }}
          className={`
            block
            lg:hidden
            absolute
            right-0
            top-0
            left-0
            bottom-0
            z-10
            transition
            transform
            duration-300
          `}
        />
        <div
          className="
            w-5/6
            lg:w-auto
            absolute
            lg:relative
            right-0
            top-0
            h-full
            flex
            flex-col
            lg:flex-row
            flex-1
            justify-start
            py-6
            px-6
            lg:py-0
            lg:px-0
            bg-white
            transition
            lg:bg-transparent
            z-20
          "
        >
          <div className="flex lg:hidden justify-between mb-8">
            <a className="flex items-center -mt-1" href="https://12glavk.iz.ru">
              <img
                className="max-w-28 max-h-29 lg:max-w-46 lg:max-h-48"
                src={Glavk12Logo}
                width="46"
                height="48"
                alt=""
              />
              <span className="ml-4">
                <img
                  className="max-w-83 max-h-60 lg:max-w-133 lg:max-h-60"
                  src={Glavk12Text}
                  width="133"
                  height="60"
                  alt=""
                />
              </span>
            </a>
          </div>
          <NavLink
            className="ml-0 lg:ml-12 py-2.5 lg:py-0"
            to="people"
            activeStyle={{
              fontWeight: "bold",
            }}
            onClick={clickChangeShow}
          >Люди</NavLink>
          <NavLink
            className="ml-0 lg:ml-9 py-2.5 lg:py-0"
            to="parity"
            activeStyle={{
              fontWeight: "bold",
            }}
            onClick={clickChangeShow}
          >Путь к паритету</NavLink>
          <NavLink
            className="ml-0 lg:ml-9 py-2.5 lg:py-0"
            to="science"
            activeStyle={{
              fontWeight: "bold",
            }}
            onClick={clickChangeShow}
          >Хайтек и наука</NavLink>
          <NavLink
            className="ml-0 lg:ml-9 py-2.5 lg:py-0"
            to="work"
            activeStyle={{
              fontWeight: "bold",
            }}
            onClick={clickChangeShow}
          >Боевая работа</NavLink>
          {/* <NavLink to="">Интерактивная карта</NavLink> */}
        </div>
      </div>
      <span
        onClick={clickChangeShow}
        className="
          absolute
          lg:hidden
          z-20
          right-0
          top-0
          w-14
          h-13
          justify-center
          items-center
          cursor-pointer
          flex
          lg:mt-0.5
        "
      >
        {show ?
          <img
            src={menuMobileClose}
            width="18"
            height="18"
            alt=""
          />
          :
          <img
            src={menuMobile}
            width="18"
            height="18"
            alt=""
          />
        }
      </span>
      <a className="hidden lg:flex items-center mt-0.5" target="_blank" rel="noreferrer" href="https://iz.ru">
        <img
          src={IZRULogo}
          width="112"
          height="42"
          alt=""
        />
      </a>
    </header>
  );
}